export default "__VITE_ASSET__CQgkpeEn__"